import React, { useEffect } from "react";
import ForgotPasswordComp from "../Components/ForgotPassword/ForgotPassword";
const ForgotPassword = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <ForgotPasswordComp />;
};

export default ForgotPassword;
